"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TICKERS = exports.Ticker = void 0;
exports.Ticker = {
    USD: 'USD',
    EUR: 'EUR',
    UAH: 'UAH',
    KZT: 'KZT',
    BTC: 'BTC',
    ETH: 'ETH',
    USDT: 'USDT',
    USDC: 'USDC',
    BUSD: 'BUSD',
    LINK: 'LINK',
    WBTC: 'WBTC',
    TRX: 'TRX',
    BNB: 'BNB',
    UNI: 'UNI',
    HEX: 'HEX',
    LTT: 'LTT',
    '1INCH': '1INCH',
    AAVE: 'AAVE',
    TLM: 'TLM',
    ATA: 'ATA',
    BAKE: 'BAKE',
    BCH: 'BCH',
    ADA: 'ADA',
    CHZ: 'CHZ',
    COMP: 'COMP',
    DOGE: 'DOGE',
    FTM: 'FTM',
    GRT: 'GRT',
    KNC: 'KNC',
    LTC: 'LTC',
    MATIC: 'MATIC',
    CAKE: 'CAKE',
    DOT: 'DOT',
    REN: 'REN',
    RSR: 'RSR',
    XRP: 'XRP',
    SFP: 'SFP',
    SHIB: 'SHIB',
    SUSHI: 'SUSHI',
    SNX: 'SNX',
    TUSD: 'TUSD',
    TWT: 'TWT',
    VET: 'VET',
    YFI: 'YFI',
    VOLT: 'VOLT',
    PLA: 'PLA',
    ZEDXION: 'ZEDXION',
    ZEDXIONC: 'ZEDXIONC',
    USDZ: 'USDZ',
    IRR: 'IRR',
    IMX: 'IMX',
    CRV: 'CRV',
    ATOM: 'ATOM',
    APE: 'APE',
    NEAR: 'NEAR',
    GMT: 'GMT',
    DYDX: 'DYDX',
    LIT: 'LIT',
    SAND: 'SAND',
    SBX: 'SBX',
    STR: 'STR',
    DONR: 'DONR',
    INTDv1: 'INTDv1',
    INTD: 'INTD',
    FUNEX: 'FUNEX',
    HLS: 'HLS',
    SVR: 'SVR',
    MOLT: 'MOLT',
    SHF: 'SHF',
    OJS: 'OJS',
    TGR: 'TGR',
    CRED: 'CRED',
    PEPE: 'PEPE'
};
exports.TICKERS = Object.values(exports.Ticker);
//# sourceMappingURL=data:application/json;base64,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